import type { IStep } from '@ben/shared/types/columbia';

const hasComponentType = (component: IStep['components'][number]): boolean =>
  Boolean(component.type);

const isRealStep = (step: IStep): boolean =>
  step.id != null || Boolean(step.tempId);

export const sanitizeStepsForSave = (steps: IStep[]): IStep[] =>
  steps
    .filter((step) => isRealStep(step))
    .map((step, index) => ({
      ...step,
      rank: index,
      components: (step.components ?? []).filter((component) =>
        hasComponentType(component)
      ),
    }));
